// @ts-nocheck
import * as Types from '../../../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type CommunitiesStepQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CommunitiesStepQuery = { __typename?: 'Query', communities: { __typename?: 'CommunitiesPageResult', entities: Array<{ __typename?: 'Community', id: string, name: string, latitude?: number | null | undefined, longitude?: number | null | undefined, pricingTeaser?: string | null | undefined, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, showInCheckout: boolean, minProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, maxProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, sellableSqft?: number | null | undefined } }> }> } };

export type CommunitiesStep_UserHasConfigsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.CheckoutConfigsFilter>;
}>;


export type CommunitiesStep_UserHasConfigsQuery = { __typename?: 'Query', checkoutConfigs: { __typename?: 'CheckoutConfigsPage', entities: Array<{ __typename?: 'CheckoutConfig', id: string }> } };

export type CommunitiesStep_CommunityFragment = { __typename?: 'Community', id: string, name: string, latitude?: number | null | undefined, longitude?: number | null | undefined, pricingTeaser?: string | null | undefined, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, showInCheckout: boolean, minProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, maxProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, sellableSqft?: number | null | undefined } }> };

export type CommunitiesStep_Community_ProductOfferingFragment = { __typename?: 'ProductOffering', id: string, showInCheckout: boolean, minProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, maxProgramData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, sellableSqft?: number | null | undefined } };

export const CommunitiesStep_Community_ProductOfferingFragmentDoc = gql`
    fragment CommunitiesStep_Community_ProductOffering on ProductOffering {
  id
  showInCheckout
  minProgramData {
    id
    bedrooms
    fullBaths
    halfBaths
    sellableSqft
  }
  maxProgramData {
    id
    bedrooms
    fullBaths
    halfBaths
    sellableSqft
  }
}
    `;
export const CommunitiesStep_CommunityFragmentDoc = gql`
    fragment CommunitiesStep_Community on Community {
  id
  name
  latitude
  longitude
  pricingTeaser
  productOfferings {
    ...CommunitiesStep_Community_ProductOffering
  }
}
    ${CommunitiesStep_Community_ProductOfferingFragmentDoc}`;
export const CommunitiesStepDocument = gql`
    query CommunitiesStep {
  communities(filter: {showInCheckout: true}) {
    entities {
      ...CommunitiesStep_Community
    }
  }
}
    ${CommunitiesStep_CommunityFragmentDoc}`;

/**
 * __useCommunitiesStepQuery__
 *
 * To run a query within a React component, call `useCommunitiesStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunitiesStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunitiesStepQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommunitiesStepQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CommunitiesStepQuery, CommunitiesStepQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CommunitiesStepQuery, CommunitiesStepQueryVariables>(CommunitiesStepDocument, options);
      }
export function useCommunitiesStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CommunitiesStepQuery, CommunitiesStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CommunitiesStepQuery, CommunitiesStepQueryVariables>(CommunitiesStepDocument, options);
        }
export type CommunitiesStepQueryHookResult = ReturnType<typeof useCommunitiesStepQuery>;
export type CommunitiesStepLazyQueryHookResult = ReturnType<typeof useCommunitiesStepLazyQuery>;
export type CommunitiesStepQueryResult = Apollo.QueryResult<CommunitiesStepQuery, CommunitiesStepQueryVariables>;
export const CommunitiesStep_UserHasConfigsDocument = gql`
    query CommunitiesStep_UserHasConfigs($filter: CheckoutConfigsFilter) {
  checkoutConfigs(filter: $filter, page: {limit: 1}) {
    entities {
      id
    }
  }
}
    `;

/**
 * __useCommunitiesStep_UserHasConfigsQuery__
 *
 * To run a query within a React component, call `useCommunitiesStep_UserHasConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunitiesStep_UserHasConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunitiesStep_UserHasConfigsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCommunitiesStep_UserHasConfigsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CommunitiesStep_UserHasConfigsQuery, CommunitiesStep_UserHasConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CommunitiesStep_UserHasConfigsQuery, CommunitiesStep_UserHasConfigsQueryVariables>(CommunitiesStep_UserHasConfigsDocument, options);
      }
export function useCommunitiesStep_UserHasConfigsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CommunitiesStep_UserHasConfigsQuery, CommunitiesStep_UserHasConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CommunitiesStep_UserHasConfigsQuery, CommunitiesStep_UserHasConfigsQueryVariables>(CommunitiesStep_UserHasConfigsDocument, options);
        }
export type CommunitiesStep_UserHasConfigsQueryHookResult = ReturnType<typeof useCommunitiesStep_UserHasConfigsQuery>;
export type CommunitiesStep_UserHasConfigsLazyQueryHookResult = ReturnType<typeof useCommunitiesStep_UserHasConfigsLazyQuery>;
export type CommunitiesStep_UserHasConfigsQueryResult = Apollo.QueryResult<CommunitiesStep_UserHasConfigsQuery, CommunitiesStep_UserHasConfigsQueryVariables>;